import { render, staticRenderFns } from "./RcpDescLink.vue?vue&type=template&id=727de22a&"
import script from "./RcpDescLink.vue?vue&type=script&lang=js&"
export * from "./RcpDescLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports